<template>
    <splitalerts type="org" />
</template>


<script>
import splitalerts from './SplitAlerts.vue'
export default {
    name: 'split-alerts-org',
    components: {
        splitalerts
    }
}
</script>
